import type { PropsWithChildren } from 'react';

import './EditoContainer.scss';

type Props = {
  title: string;
  subTitle: string;
  sectionOptional?: boolean;
};

export const EditoContainer = ({
  subTitle,
  title,
  sectionOptional,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div className="editoContainer">
      <div className="titleContainer">
        <div>
          <span className="title">{title}</span>
          {sectionOptional && <span className="optionalTitle">(optional)</span>}
        </div>
        <span className="subTitle">{subTitle}</span>
      </div>

      <div className="childrenContainer">{children}</div>
    </div>
  );
};
